/* istanbul ignore file */
export default {
  candidateId: {
    type: 'string',
    required: true,
  },
  vacancyAlias: {
    type: 'string',
    required: true,
  },
  resume: {
    type: 'object',
    required: false,
    properties: {
      resumeArtifactIds: {
        type: 'array',
        maxSize: 1,
      },
    },
  },
  source: {
    type: 'string',
    required: true,
  },
  sourceType: {
    type: 'enum',
    required: true,
  },
  sourceComment: {
    type: 'string',
    maxSize: 255,
    required: false,
  },
  note: {
    type: 'object',
    properties: {
      noteText: {
        type: 'string',
        required: {
          value: true,
          when: {
            '$note.attachmentsIds': {
              ne: [],
            },
          },
        },
        maxSize: 65000,
      },
      attachmentsIds: {
        type: 'array',
        maxSize: 5,
      },
    },
  },
  candidate: {
    type: 'object',
    required: false,
  },
};
